import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { debug } from 'console';
import { start } from 'repl';
import { LoginService } from 'src/app/login/login.service';
import { UserModel } from 'src/models/user.model';
import { AuthService } from './auth.service';
import { LocalStoreManager } from './local-store-manager.service';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private loginService: LoginService, private router: Router, private storage: LocalStoreManager) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;
/*    const request = this.storage.getData('posPaymentModelReq');*/
    //const hasUser: UserModel = this.storage.getData('user');
    //if (this.authService.isUserLoggedIn() || (hasUser && hasUser.loginDate && this.datevalidator(hasUser.loginDate))) {
    if (this.authService.isUserLoggedIn()) {
      return true;
    }
    this.authService.setRedirectUrl(url);
    this.router.navigate([this.authService.getLoginUrl()]);
    return false;
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //       let loggedInUser= this.authService.getLoggedInUser();
    // if (loggedInUser.role ==='ADMIN') {
    //         return true;
    // } else {
    // 	console.log('Unauthorized to open link: '+ state.url);
    // 	return false;
    // }
    // }
    return false;
  }
  datevalidator(loginDate: Date): boolean {
    const endDate = new Date();
    const startDate = new Date(loginDate);
    if (endDate.getDate() !== startDate.getDate() && endDate.getHours() > startDate.getHours())
      return false;
    else
      return true;
  }
}
